import { EditIcon } from "../../images/deliveries/deliveriesModals/editIcon";
import { BaseTable } from "../../components/UI/baseTable/BaseTable";
import { DeleteIcon } from "../../images/deliveries/deliveriesModals/deleteIcon";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { getCustomerDrafts } from "../../redux/integrations/getCustomerDrafts";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsEditMode,
  setSelectedDataForEdit,
  toggleAddNewCustomerAddress,
  toggleDeleteCustomerAddressModal,
} from "../../redux/globalFunctions/globalFnSlice";

export function CustomerDrafts() {
  const dispatch = useDispatch();
  const { t } = useTranslations();
  const addressesPage = t.addresses;
  const integrationsPage = t.integrations;

  const { status: createStatus } = useSelector((state) => state.createCustomer);
  const { customers, status, filtered_count, total_count } = useSelector(
    (state) => state.getCustomerDrafts
  );
  const { status: deleteStatus } = useSelector(
    (state) => state.deleteCustomerDraft
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [isFiltered, setIsFiltered] = useState(false);

  useEffect(() => {
    if (currentPage > 1) {
      setIsFiltered(true);
    }
  }, [currentPage]);

  useEffect(() => {
    dispatch(getCustomerDrafts({ page: currentPage }));
  }, [currentPage]);

  useEffect(() => {
    if (createStatus === "success" || deleteStatus === "success") {
      dispatch(getCustomerDrafts({ page: currentPage }));
    }
  }, [createStatus, deleteStatus]);

  const columns = [
    {
      label: addressesPage.table.customer.customer,
    },
    { label: addressesPage.table.address },
    { label: addressesPage.table.phone },
    { label: addressesPage.table.edit },
    { label: addressesPage.table.delete },
  ];

  const totalPages = Math.ceil(total_count / 10);
  const filteredPages = Math.ceil(filtered_count / 10);

  function handleEditClick(data) {
    dispatch(setSelectedDataForEdit(data));
    dispatch(setIsEditMode(true));
    dispatch(toggleAddNewCustomerAddress(data));
  }

  return (
    <BaseTable
      status={status}
      resultsContainerHeight={"calc(100vh - 250px)"}
      errorMsg={integrationsPage.errorFetchingDrafts}
      noItemsMsg={integrationsPage.noDrafts}
      items={customers}
      columns={columns}
      columnAndRowWidth={"200px"}
      pagination={true}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      totalPages={totalPages}
      filteredPages={filteredPages}
      isFiltered={isFiltered}
      rows={
        customers &&
        customers?.map((item) => [
          item.dc_name,
          item.dc_address,
          item.dc_phonenumber,
          <EditIcon onClick={() => handleEditClick(item)} />,
          <DeleteIcon
            onClick={() => dispatch(toggleDeleteCustomerAddressModal(item))}
          />,
        ])
      }
    />
  );
}
